export const AVAILABLE_LOCALIZATIONS = [
    'bg',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fi',
    'fr',
    'hr',
    'hu',
    'it',
    'ja',
    'ko',
    'lt',
    'lv',
    'no',
    'pl',
    'pt',
    'ro',
    'sk',
    'sl',
    'sv',
    'tr',
    'uk',
];
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_NAVIGATOR_LANGUAGE = 'en-US';

export const LANG_TO_LOCALE_MAP: Record<string, string> = {
    bg: 'bg-BG', // Bulgarian - Bulgaria
    cs: 'cs-CZ', // Czech - Czech Republic
    da: 'da-DK', // Danish - Denmark
    de: 'de-DE', // German - Germany
    el: 'el-GR', // Greek - Greece
    en: 'en-US', // English - United States
    es: 'es-ES', // Spanish - Spain
    et: 'et-EE', // Estonian - Estonia
    fi: 'fi-FI', // Finnish - Finland
    fr: 'fr-FR', // French - France
    hr: 'hr-HR', // Croatian - Croatia
    hu: 'hu-HU', // Hungarian - Hungary
    it: 'it-IT', // Italian - Italy
    ja: 'ja-JP', // Japanese - Japan
    ko: 'ko-KR', // Korean - South Korea
    lt: 'lt-LT', // Lithuanian - Lithuania
    lv: 'lv-LV', // Latvian - Latvia
    no: 'nb-NO', // Norwegian Bokmål - Norway
    pl: 'pl-PL', // Polish - Poland
    pt: 'pt-BR', // Portuguese - Brazil
    ro: 'ro-RO', // Romanian - Romania
    sk: 'sk-SK', // Slovak - Slovakia
    sl: 'sl-SI', // Slovene - Slovenia
    sv: 'sv-SE', // Swedish - Sweden
    tr: 'tr-TR', // Turkish - Turkey
    uk: 'uk-UA', // Ukrainian - Ukraine
};
